import React, { useState } from 'react';
import { toast } from 'react-toastify';

const currentDomain = () => {
    if (location.origin.startsWith('http://localhost')) {
        return 'http://localhost:3001';
    } else {
        return location.origin;
    }
};

const JudgeForm = ({ isOpen, onClose }) => {
    // State for form fields
    const [formData, setFormData] = useState({
        firstName: '',
        lastName: '',
        email: '',
        isAdmin: false,
        checkedIn: false,
        phone: '',
    });

    const clearForm = () => {
        setFormData({
            firstName: '',
            lastName: '',
            email: '',
            isAdmin: false,
            checkedIn: false,
            phone: '',
        });
    };

    // Handle form input changes
    const handleChange = (e) => {
        const { name, type, value, checked } = e.target;
        setFormData({
            ...formData,
            [name]: type === 'checkbox' ? checked : value,
        });
    };

    // Handle form submission
    const handleSubmit = (e) => {
        e.preventDefault(); 
        console.log('Form submitted:', formData);
        fetch(`${currentDomain(location)}/api/register/judge`, {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
            },
            body: JSON.stringify(formData),
        }).then((response) => {
            if (response.status == 409) {
                toast.error("Judge already exists.");
                return;
            } else if (!response.ok) {
                throw new Error();
            } else {
                toast.success("Judge successfully registered");
                clearForm();
                onClose(); // Close the modal after successful submission
            }
        }).catch((error) => {
            toast.error("Error submitting judge. Please try again. If error persists, contact staff.");
            return;
        });
    };

    if (!isOpen) {
        return null; // Do not render anything if the modal is not open
    }

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center">
            {/* Overlay */}
            <div className="fixed inset-0 bg-black opacity-50" onClick={onClose}></div>
            {/* Modal content */}
            <div className="bg-white rounded shadow-xl z-50 max-w-4xl mx-auto p-8 relative">
                <button
                    className="absolute top-2 right-2 text-gray-500 hover:text-gray-700 text-2xl font-bold"
                    onClick={onClose}
                >
                    &times;
                </button>
                <form onSubmit={handleSubmit} className="px-8 py-6">
                    <div>
                        <h1 className="font-bold text-2xl pt-8">Register Judge</h1>
                    </div>

                    {/* Personal Information */}
                    <div className="lg:flex gap-4">
                        <div className="lg:w-1/2 w-full">
                            <label className="block text-lg font-semibold">First Name</label>
                            <input
                                type="text"
                                name="firstName"
                                value={formData.firstName}
                                onChange={handleChange}
                                className="w-full border border-gray-300 p-2 rounded"
                            />
                        </div>
                        <div className="lg:w-1/2 w-full">
                            <label className="block text-lg font-semibold">Last Name</label>
                            <input
                                type="text"
                                name="lastName"
                                value={formData.lastName}
                                onChange={handleChange}
                                className="w-full border border-gray-300 p-2 rounded"
                            />
                        </div>
                    </div>

                    <div className="lg:flex gap-4 mt-4">
                        <div className="lg:w-1/2 w-full">
                            <label className="block text-lg font-semibold">Email</label>
                            <input
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                className="w-full border border-gray-300 p-2 rounded"
                            />
                        </div>
                        <div className="lg:w-1/2 w-full">
                            <label className="block text-lg font-semibold">Phone</label>
                            <input
                                type="tel"
                                name="phone"
                                value={formData.phone}
                                onChange={handleChange}
                                className="w-full border border-gray-300 p-2 rounded"
                            />
                        </div>
                    </div>

                    <div className="mt-4">
                        <label className="inline-flex items-center">
                            <input
                                type="checkbox"
                                name="isAdmin"
                                checked={formData.isAdmin}
                                onChange={handleChange}
                                className="form-checkbox"
                            />
                            <span className="ml-2 text-lg">Admin</span>
                        </label>
                    </div>

                    <div className="mt-2">
                        <label className="inline-flex items-center">
                            <input
                                type="checkbox"
                                name="checkedIn"
                                checked={formData.checkedIn}
                                onChange={handleChange}
                                className="form-checkbox"
                            />
                            <span className="ml-2 text-lg">Checked In</span>
                        </label>
                    </div>

                    <div className="h-px w-full bg-black my-7" />

                    <button
                        type="submit"
                        className="bg-blue-500 text-white py-2 px-4 rounded hover:bg-blue-600"
                    >
                        Submit
                    </button>
                </form>
            </div>
        </div>
    );
};

export default JudgeForm;
